module.exports = __webpack_public_path__ + "img/add-logo.90bb9e4f.png";